import React from "react";
import { connect } from "react-redux";
import ClaimHeader from './Components/ClaimHeader/ClaimHeader'
import ClaimChecks from '../../../components/ClaimChecks/index.es6'
import { normaliseChecklist } from '../../../components/ClaimChecks/claimChecksLib.es6'
import ClaimDetails from './Components/ClaimDetails/ClaimDetails'
import ClaimDocuments from './Components/ClaimDocuments/ClaimDocuments'
import ClaimExpenses from './Components/ClaimExpenses/ClaimExpenses'
import ClaimAudit from "./Components/ClaimAudit/ClaimAudit";
import ClaimActionButtons from './Components/ClaimActionButtons'
import * as actions from "./Redux/actions"
import BoxInc from "../../../shared-ui/BoxInc/Index";
import ButtonInc from '../../../shared-ui/ButtonInc';
import AddClaimNotes from "./Components/ClaimDetails/AddClaimNotes";
import ClaimNotes from "./Components/ClaimDetails/ClaimNotes";
import AddClaimDocuments from "./Components/ClaimDocuments/AddClaimDocuments";
import AddClaimExpense from "./Components/ClaimExpenses/AddClaimExpense";
import DeleteClaimExpense from "./Components/ClaimExpenses/DeleteClaimExpense";
import EditClaimDetails from "./Components/ClaimExpenses/EditClaimDetails";
import DeleteClaimDocument from "./Components/ClaimDocuments/DeleteClaimDocument";
import AddClaimFacilityNotes from "./Components/ClaimDetails/AddClaimFacilityNotes";
import find from 'lodash/find';
import { getPartnerGuid, hasAuthourity } from "../../../lib/access.es6";
import { ClaimTypeEnum } from "../lib/enum";
import { hashHistory } from 'react-router';
import DownloadDocument from "../../../components/DownloadDocument/DownloadDocument";
import * as documentActions from '../../../containers/DocumentGeneration/actions.es6';
import LocalizedStrings from 'react-localization';
import { localisedText } from "../../../lib/localisation.es6";
import WaitingPeriodApprovalReason from "./Components/ClaimActionButtons/WaitingPeriodApprovalReason";
import { OLD_MUTUAL_MALAWI_FUNERAL_BENEFITS } from "../../../lib/constants";
import { getPolicyByGuidDcp } from "../../../lib/requests.es6";
import SettlementDocuments from "./Components/SettlementDocuments/SettlementDocuments";
import { PARTNERS_GUID_ENUM } from "../../../routes/PartnersEnum";



class ClaimsProcessing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      labels: new LocalizedStrings(localisedText),
      openClaimNotesDialog: false,
      openClaimFacilityNotesDialog: false,
      openClaimDocumentsDialog: false,
      openClaimExpenseDialog: false,
      openEditClaimExpenseDialog: false,
      description: "",
      expanded: false,
      missingDocs: false,
      claimToDownload: null,
      openClaimWaitingPeriodDialog: false,
      policy: null,
      policyLoading: false,
    };
  }

  componentWillMount() {
    let claim_guid = this.props.params.claim_guid;
    this.props.dispatch(
      actions.getClaimProcessingDcpRequest({
        guid: claim_guid,
      })
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.openClaimDocumentsDialog === true &&
      this.state.openClaimDocumentsDialog === false
    ) {
      let claim_guid = this.props.params.claim_guid;
      this.props.dispatch(
        actions.getClaimProcessingDcpRequest({
          guid: claim_guid,
        })
      );
    }

    const prevClaim = prevProps.claimProcessingv2Data.claimsProcessingDcp;
    const claim = this.props.claimProcessingv2Data.claimsProcessingDcp;

    console.log("prev claim", prevClaim);
    console.log("current claim", claim);

    // Fetch the policy for EVERY claim, not only one on grace period. The grace
    // period banner was the first thing to need it, so the fetch was gated on that
    // flag — but the declared-condition reader and the required-document checklist
    // need it too, and for an ordinary claim they were being handed a null policy.
    // OMK records a declared medical condition on the policy and nowhere else, so
    // with no policy loaded every life read as "None declared" and the first-year
    // cap could never apply.
    if (claim && claim !== prevClaim && claim.policy_guid) {
      this.fetchPolicy(claim.policy_guid);
    }
  }


  fetchPolicy = async (policyGuid) => {
    try {
      this.setState({ policyLoading: true });
      console.log("fetchPolicy called with guid", policyGuid);

      // Call the API directly
      const response = await getPolicyByGuidDcp({ policy_guid: policyGuid });
      const policy = response.data;



      console.log("fetched policy", policy);

      this.setState({ policy, policyLoading: false });
    } catch (error) {
      console.error("Error fetching policy:", error);
      this.setState({ policy: null, policyLoading: false });
    }
  };

  toggleClaimNotesDialog() {
    this.setState({ openClaimNotesDialog: !this.state.openClaimNotesDialog });
  }

  toggleClaimFacilityNotesDialog() {
    this.setState({
      openClaimFacilityNotesDialog: !this.state.openClaimFacilityNotesDialog,
    });
  }

  toggleClaimDocumentsDialog() {
    this.setState({
      openClaimDocumentsDialog: !this.state.openClaimDocumentsDialog,
    });
  }

  toggleClaimExpenseDialog() {
    this.setState({
      openClaimExpenseDialog: !this.state.openClaimExpenseDialog,
      expanded: true,
    });
  }

  toggleEditClaimExpenseDialog() {
    this.setState({
      openEditClaimExpenseDialog: !this.state.openEditClaimExpenseDialog,
    });
  }

  // toggleWaitingPeriodApprovedDialog(){
  //   this.setState({ openClaimWaitingPeriodDialog: !this.state.openClaimWaitingPeriodDialog })
  // }

  toggleWaitingPeriodApprovedDialog = (open) => {
    this.setState({ openClaimWaitingPeriodDialog: open });
  };

  handleClaimExpense(payload) {
    this.props.dispatch(actions.createExpenseRequest(payload));
  }

  setClaimExpenseToDelete(expense) {
    this.props.dispatch(actions.setExpenseToDelete(expense));
  }
  deleteClaimExpense(expense) {
    this.props.dispatch(
      actions.deleteExpenseRequest({
        claim_guid: this.props.claimProcessingv2Data.claimsProcessingDcp.guid,
        expense_guid: expense.guid,
      })
    );
  }
  resetExpenseToDelete(expense) {
    this.props.dispatch(actions.resetExpenseToDelete(expense));
  }

  setClaimExpenseToEdit(expense) {
    console.log("set claim to edit", expense);
    this.props.dispatch(actions.setExpenseToEdit(expense));
  }

  editClaimExpense(payload) {
    this.props.dispatch(actions.expenseEditRequest(payload));
  }
  resetExpenseToEdit(expense) {
    this.props.dispatch(actions.resetExpenseEdit(expense));
  }
  handleClaimNotes(payload) {
    this.props.dispatch(actions.createClaimNote(payload));
  }

  handleClaimFacilityNotes(payload) {
    this.props.dispatch(actions.claimFacilityNotesRequest(payload));
  }

  deleteClaimDocument(document) {
    this.props.dispatch(
      actions.deleteclaimDocumentsRequest({
        claim_guid: this.props.claimProcessingv2Data.claimsProcessingDcp.guid,
        claim_doc_guid: document.guid,
      })
    );
  }
  setClaimDocumentToDelete(document) {
    console.log("set claimdocument to delete", document);
    this.props.dispatch(actions.setDocumentsToDelete(document));
  }

  resetDocumentToDelete(document) {
    this.props.dispatch(actions.resetDocumentToDelete(document));
  }
  getPreauthDetails(guid) {
    this.props.dispatch(actions.getPreauthDetailsRequest(guid));
  }

  isCashbackClaim(claim) {
    const hasCashbackBenefit = !!find(claim.benefits, { type: "Cashback" });
    return hasCashbackBenefit;
  }

  isFuneralNaturalClaim(claim) {
    const partnerGuid = getPartnerGuid();
    const hasFuneralNaturalDeath =
      partnerGuid === "omk"
        ? !!find(claim.benefits, { type: "Last_Expense" }) ||
          !!find(claim.benefits, { type: "Last Expense" })
        : !!find(claim.benefits, { type: "Funeral Natural Death" });
    console.log("hasFuneralNaturalDeath", hasFuneralNaturalDeath);
    return hasFuneralNaturalDeath;
  }

  isFuneralAccidentalDeathClaim(claim) {

    const hasFuneralAccidentalDeath = !!find(claim.benefits, {
      type: "Funeral Accidental Death",
    }) || !!find(claim.benefits, {
      type: "Funeral_Accidental_Death",
    });
    console.log("hasFuneralAccidentalDeath", hasFuneralAccidentalDeath);
    return hasFuneralAccidentalDeath;
  }

  isHospiCashIllnessBenefitClaim(claim) {
    const hasHospiCashIllnessBenefit = !!find(claim.benefits, {
      type: "Hospi Cash Illness Benefit",
    });
    console.log("hasHospiCashIllnessBenefit", hasHospiCashIllnessBenefit);
    return hasHospiCashIllnessBenefit;
  }

  isDeathClaim(claim) {
    const hasAccidentalDeath = !!find(claim.benefits, { type: "Accidental Death" }) || !!find(claim.benefits, { type: "Natural Death" }) || !!find(claim.benefits, { type: "Accidental_Death" }) || !!find(claim.benefits, { type: "Natural_Death" });
    console.log("hasAccidentalDeath", hasAccidentalDeath);
    return hasAccidentalDeath;
  }
  isDisabilityClaim(claim) {
    const hasPartialPermanentDisability = !!find(claim.benefits, { type: "Partial Permanent Disability" }) || !!find(claim.benefits, { type: "Total Permanent Disability" }) || !!find(claim.benefits, { type: "Partial_Permanent_Disability" }) || !!find(claim.benefits, { type: "Total_Permanent_Disability" });
    console.log("hasPartialPermanentDisability", hasPartialPermanentDisability);
    return hasPartialPermanentDisability;
  }



  isRewardsBenefitClaim(claim) {
    const hasRewardsBenefits = !!find(claim.benefits, { type: "Rewards" });
    return hasRewardsBenefits;
  }

  isHospiCashAccidentBenefitClaim(claim) {
    const hasHospiCashAccidentBenefit = !!find(claim.benefits, {
      type: "Hospi Cash Accident Benefit",
    });
    return hasHospiCashAccidentBenefit;
  }

  isOldMutualMalawiFuneralClaim(claim) {
    const hasOldMutualMalawiFuneralBenefits = !!find(claim.benefits, (benefit) => {
      return OLD_MUTUAL_MALAWI_FUNERAL_BENEFITS.includes(benefit.type)
    });
    return hasOldMutualMalawiFuneralBenefits;
  }





  isAccidentalDeathClaim(claim) {
    const hasAccidentalDeath = !!find(claim.benefits, { type: "Accidental Death" }) || !!find(claim.benefits, { type: "Accidental_Death" });
    return hasAccidentalDeath;
  }

  isNaturalDeathClaim(claim) {
    const hasNaturalDeath = !!find(claim.benefits, { type: "Natural Death" }) || !!find(claim.benefits, { type: "Natural_Death" });
    return hasNaturalDeath;
  }

  isPermanentDisabilityClaim(claim) {
    const hasPermanentDisability = !!find(claim.benefits, { type: "Total Permanent Disability" }) || !!find(claim.benefits, { type: "Total_Permanent_Disability" });
    return hasPermanentDisability;
  }

  isPartialPermanentDisabilityClaim(claim) {
    const hasPartialPermanentDisability = !!find(claim.benefits, { type: "Partial Permanent Disability" }) || !!find(claim.benefits, { type: "Partial_Permanent_Disability" });
    return hasPartialPermanentDisability;
  }

  getClaimType(claim) {
    if (!claim) return "";
    if (this.isCashbackClaim(claim)) return ClaimTypeEnum.Cashback;
    if (this.isFuneralNaturalClaim(claim))
      return ClaimTypeEnum.FuneralNaturalDeath;
    if (this.isFuneralAccidentalDeathClaim(claim))
      return ClaimTypeEnum.FuneralAccidentalDeath;
    if (this.isHospiCashIllnessBenefitClaim(claim))
      return ClaimTypeEnum.HospiCashIllness;
    if (this.isRewardsBenefitClaim(claim)) return ClaimTypeEnum.Rewards;
    if (this.isHospiCashAccidentBenefitClaim(claim))
      return ClaimTypeEnum.HospiCashAccident;
    if (this.isAccidentalDeathClaim(claim)) return ClaimTypeEnum.AccidentalDeath;
    if (this.isNaturalDeathClaim(claim)) return ClaimTypeEnum.NaturalDeath;
    if (this.isPermanentDisabilityClaim(claim)) return ClaimTypeEnum.TotalPermanentDisability;
    if (this.isPartialPermanentDisabilityClaim(claim)) return ClaimTypeEnum.PartialPermanentDisability;
    if (this.isOldMutualMalawiFuneralClaim(claim)) return ClaimTypeEnum.OldMutualMalawiFuneral;
    // if (this.isDeviceDamageClaim(claim)) return ClaimTypeEnum.deviceDamage
    // if (this.isParmanentDisabilityClaim(claim)) return ClaimTypeEnum.permanentDisability
    // if (this.isDeviceTheftClaim(claim)) return ClaimTypeEnum.deviceTheft
    // if (this.isTemporaryDisability(claim)) return ClaimTypeEnum.TemporaryDisability
    // if (this.isLastExpense(claim)) return ClaimTypeEnum.LastExpense
    // if (this.isProperty(claim)) return ClaimTypeEnum.Property
    // if(this.isCancer(claim)) return ClaimTypeEnum.Cancer

    return "";
  }
  viewCustomerProfile() {
    const customer_guid = this.props.claimProcessingv2Data.claimsProcessingDcp
      .customer_guid;
    if (customer_guid) {
      hashHistory.push("admin/customer_status/" + customer_guid);
    }
  }

  downloadClaimSummary() {
    this.setState({
      claimToDownload: this.props.claimProcessingv2Data.claimsProcessingDcp,
    });
  }
  render() {
    const partnerGuid = getPartnerGuid();
    const type = this.getClaimType(
      this.props.claimProcessingv2Data.claimsProcessingDcp
    );

    console.log("claim type in render", type);
    const benefits = this.props.claimProcessingv2Data.claimsProcessingDcp
      ? this.props.claimProcessingv2Data.claimsProcessingDcp.benefits
      : [];

    const hasCashbackBenefit = !!find(benefits, { type: "Cashback" });
    const hasFuneralNaturalDeath =
      partnerGuid === "omk"
        ? !!find(benefits, { type: "Last_Expense" }) ||
          !!find(benefits, { type: "Last Expense" })
        : !!find(benefits, { type: "Funeral Natural Death" });
    const hasFuneralAccidentalDeath = !!find(benefits, {
      type: "Funeral Accidental Death",
    }) || !!find(benefits, {
      type: "Funeral_Accidental_Death",
    });
    const hasHospiCashIllnessBenefit = !!find(benefits, {
      type: "Hospi Cash Illness Benefit",
    });
    const hasRewardsBenefits = !!find(benefits, { type: "Rewards" });
    const hasHospiCashAccidentBenefit = !!find(benefits, {
      type: "Hospi Cash Accident Benefit",
    });

    const CashbackBenefit = find(benefits, { type: "Cashback" });
    const FuneralNaturalDeath =
      partnerGuid === "omk"
        ? find(benefits, { type: "Last_Expense" }) ||
          find(benefits, { type: "Last Expense" })
        : find(benefits, { type: "Funeral Natural Death" });
    const FuneralAccidentalDeath = find(benefits, {
      type: "Funeral Accidental Death",
    })
    const HospiCashIllnessBenefit = find(benefits, {
      type: "Hospi Cash Illness Benefit",
    });
    const RewardsBenefits = find(benefits, { type: "Rewards" });
    const HospiCashAccidentBenefit = find(benefits, {
      type: "Hospi Cash Accident Benefit",
    });

    const hasAccidentalDeathBenefit = !!find(benefits, { type: "Accidental Death" }) || !!find(benefits, { type: "Accidental_Death" })
    const hasNaturalDeathBenefit = !!find(benefits, { type: "Natural Death" }) || !!find(benefits, { type: "Natural_Death" })
    const hasPartialPermanentDisabilityBenefit = !!find(benefits, { type: "Partial Permanent Disability" }) || !!find(benefits, { type: "Partial_Permanent_Disability" })
    const hasTotalPermanentDisabilityBenefit = !!find(benefits, { type: "Total Permanent Disability" }) || !!find(benefits, { type: "Total_Permanent_Disability" })
    const isMalawiFuneralClaim = !!find(benefits, (benefit) => {
      return OLD_MUTUAL_MALAWI_FUNERAL_BENEFITS.includes(benefit.type)
    })
    const isSambaFuneralClaim = !!find(benefits, { type: "Funeral" })



    if (!hasAuthourity("VIEW_CLAIM")) {
      return <p>You are unauthorized to view claim.</p>;
    }

    if (
      this.props.claimProcessingv2Data.get_claimsProcessingDcp_loader &&
      !this.props.claimProcessingv2Data.claimsProcessingDcp
    ) {
      return (
        <>
          <p>loading....</p>
        </>
      );
    }
    if (!this.props.claimProcessingv2Data.claimsProcessingDcp) {
      return (
        <>
          <p>nothing found </p>
        </>
      );
    }
    const templateDocuments = this.props.documentGenerationData
      .templateDocuments;


    const { policy } = this.state;
    const claim = this.props.claimProcessingv2Data.claimsProcessingDcp;



    const showAddInvoiceButton =
      partnerGuid === "omk"
        ? (!claim.is_on_grace_period || (policy && policy.status === "Full_Coverage"))
        : true; // For other partners, always show

    console.log("showAddInvoiceButton", showAddInvoiceButton);

    return (
      <>
        <ClaimHeader
          claimData={this.props.claimProcessingv2Data.claimsProcessingDcp}
        />
        <BoxInc
          title="Claims Details"
          expanded
          style={{ marginTop: "40px" }}
          actionButtons={[
            <ButtonInc
              variant="contained"
              color="primary"
              size="large"
              onClick={this.viewCustomerProfile.bind(this)}
            >
              View Customer Profile
            </ButtonInc>,
          ]}
        >
          <ClaimDetails
            claim={this.props.claimProcessingv2Data.claimsProcessingDcp}
            toggleClaimNotesDialog={this.toggleClaimNotesDialog.bind(this)}
            openClaimNotesDialog={this.state.openClaimNotesDialog}
            isHospiCashIllnessBenefitClaim={this.isHospiCashIllnessBenefitClaim.bind(
              this
            )}
            isHospiCashAccidentBenefitClaim={this.isHospiCashAccidentBenefitClaim.bind(
              this
            )}
            isFuneralAccidentalDeathClaim={this.isFuneralAccidentalDeathClaim.bind(
              this
            )}
            isFuneralNaturalClaim={this.isFuneralNaturalClaim.bind(this)}
            isDeathClaim={this.isDeathClaim.bind(this)}
            isDisabilityClaim={this.isDisabilityClaim.bind(this)}
            isOldMutualMalawiFuneralClaim={this.isOldMutualMalawiFuneralClaim.bind(this)}
            // The declared medical condition lives on the policy, not the claim.
            policy={this.state.policy}
          />
          <AddClaimFacilityNotes
            toggleClaimFacilityNotesDialog={this.toggleClaimFacilityNotesDialog.bind(
              this
            )}
            openClaimFacilityNotesDialog={
              this.state.openClaimFacilityNotesDialog
            }
            handleClaimFacilityNotes={this.handleClaimFacilityNotes.bind(this)}
            claimguid={
              this.props.claimProcessingv2Data.claimsProcessingDcp.guid
            }
            showCreateFacilityNoteProgressAlert={
              this.props.claimProcessingv2Data.ClaimFacilityNotesLoader
            }
            showCreateFacilityNotesSuccessAlert={
              this.props.claimProcessingv2Data.ClaimFacilityNotesSuccess
            }
            showCreateFacilityNotesErrorAlert={
              !!this.props.claimProcessingv2Data.ClaimFacilityNotesError
            }
            CreateFacilityNotesError={
              this.props.claimProcessingv2Data.ClaimFacilityNotesError
            }
            resetCreateFacilityNotesSuccessAlert={() => {
              this.props.dispatch(actions.resetFacilityClaimNotesSuccess());
            }}
            resetCreateFacilityNotesErrorAlert={() => {
              this.props.dispatch(actions.resetCreateExpenseError());
            }}
          />
        </BoxInc>
        {partnerGuid === PARTNERS_GUID_ENUM.SAMBA && (
          <BoxInc title="Settlement Documents" expanded style={{ marginTop: "30px" }}>
            <SettlementDocuments key={claim.guid} claim={claim} />
          </BoxInc>
        )}
        <BoxInc title="Claims Documents " style={{ marginTop: "30px" }}>
          <AddClaimDocuments
            description={this.state.description}
            toggleClaimDocumentsDialog={this.toggleClaimDocumentsDialog.bind(
              this
            )}
            openClaimDocumentsDialog={this.state.openClaimDocumentsDialog}
            claim_guid={
              this.props.claimProcessingv2Data.claimsProcessingDcp.guid
            }
            saveClaimDocument={(doc) =>
              this.props.dispatch(actions.saveClaimDcpDocumentRequest(doc))
            }
            error={this.props.claimProcessingv2Data.saveClaimDcpDocumentError}
            requiredDocuments={normaliseChecklist(
              this.props.claimProcessingv2Data.claimsProcessingDcp
                .required_documents_checklist
            )}
          />
          <ClaimDocuments
            setDescription={(description) => this.setState({ description })}
            claimDocuments={
              this.props.claimProcessingv2Data.claimsProcessingDcp
                .claim_documents
            }
            setClaimDocumentToDelete={this.setClaimDocumentToDelete.bind(this)}
            toggleMissingDocs={(hasMissing) => this.setState({ missingDocs: hasMissing })}
            claimDetails={this.props.claimProcessingv2Data.claimsProcessingDcp}
            missingDocs={this.state.missingDocs}
            openUploadDialog={this.toggleClaimDocumentsDialog.bind(this)}
            type={type}
            // So the required-document checklist caps the payout on the same inputs
            // the expenses dialog does, rather than on the registered cover.
            policy={this.state.policy}
          />
          <DeleteClaimDocument
            DocumentToDelete={
              this.props.claimProcessingv2Data.documentsToDelete
            }
            deleteClaimDocument={this.deleteClaimDocument.bind(this)}
            resetDocumentToDelete={this.resetDocumentToDelete.bind(this)}
            showDeleteDocumentProgressAlert={
              this.props.claimProcessingv2Data.hardDeleteExpenseLoader
            }
            showDeleteDocumentSuccessAlert={
              this.props.claimProcessingv2Data.hardDeleteDocumentSuccess
            }
            showDeleteDocumentErrorAlert={
              !!this.props.claimProcessingv2Data.deleteClaimDocumentError
            }
            deleteDocumentError={
              this.props.claimProcessingv2Data.deleteClaimDocumentError
            }
            resetDeleteDocumentSuccessAlert={() => {
              this.props.dispatch(actions.resetHardDeleteDocumentSuccess());
            }}
            resetDeleteDocumentErrorAlert={() => {
              this.props.dispatch(actions.resetHardDeleteDocumentError());
            }}
          />
        </BoxInc>
        <ClaimChecks
          claim={this.props.claimProcessingv2Data.claimsProcessingDcp}
        />

        <BoxInc
          title={
            type === ClaimTypeEnum.death
              ? "Claim Benefits "
              : " Claim Invoices "
          }
          expanded={this.state.expanded}
          style={{ marginTop: "30px" }}
          actionButtons={[
            showAddInvoiceButton && (
              <ButtonInc
                variant="contained"
                color="primary"
                size="large"
                onClick={this.toggleClaimExpenseDialog.bind(this)}
                hasPermision={hasAuthourity("UPDATE_CLAIM")}
              >
                {type === ClaimTypeEnum.death
                  ? "Benefit Amount"
                  : " Add  invoice details"}
              </ButtonInc>
            ),
          ]}
        >
          <ClaimExpenses
            claimExpense={this.props.claimProcessingv2Data.claimsProcessingDcp}
            setClaimExpenseToDelete={this.setClaimExpenseToDelete.bind(this)}
            setClaimExpenseToEdit={this.setClaimExpenseToEdit.bind(this)}
            toggleEditClaimExpenseDialog={this.toggleEditClaimExpenseDialog.bind(
              this
            )}
            openEditClaimExpenseDialog={this.state.openEditClaimExpenseDialog}
            type={type}
            hasCashbackBenefit={hasCashbackBenefit}
            hasFuneralNaturalDeath={hasFuneralNaturalDeath}
            hasFuneralAccidentalDeath={hasFuneralAccidentalDeath}
            hasHospiCashIllnessBenefit={hasHospiCashIllnessBenefit}
            hasRewardsBenefits={hasRewardsBenefits}
            hasHospiCashAccidentBenefit={hasHospiCashAccidentBenefit}
            CashbackBenefit={CashbackBenefit}
            FuneralNaturalDeath={FuneralNaturalDeath}
            FuneralAccidentalDeath={FuneralAccidentalDeath}
            HospiCashIllnessBenefit={HospiCashIllnessBenefit}
            RewardsBenefits={RewardsBenefits}
            HospiCashAccidentBenefit={HospiCashAccidentBenefit}
            hasAccidentalDeathBenefit={hasAccidentalDeathBenefit}
            hasNaturalDeathBenefit={hasNaturalDeathBenefit}
            hasPartialPermanentDisabilityBenefit={hasPartialPermanentDisabilityBenefit}
            hasTotalPermanentDisabilityBenefit={hasTotalPermanentDisabilityBenefit}
            isOldMutualMalawiFuneralClaim={isMalawiFuneralClaim}
            downloadClaimSummary={this.downloadClaimSummary.bind(this)}
          />

          <AddClaimExpense
            toggleClaimExpenseDialog={this.toggleClaimExpenseDialog.bind(this)}
            openClaimExpenseDialog={this.state.openClaimExpenseDialog}
            claim={this.props.claimProcessingv2Data.claimsProcessingDcp}
            // The dialog already reads `props.policy` to cap what it books; it was
            // never given one, so payableForClaim saw an empty policy and the
            // declared-condition cap could not apply here either.
            policy={this.state.policy}
            handleClaimExpense={this.handleClaimExpense.bind(this)}
            showCreateExpenseProgressAlert={
              this.props.claimProcessingv2Data.createdClaimExpenseLoader
            }
            showCreateExpenseSuccessAlert={
              this.props.claimProcessingv2Data.createdClaimExpenseSuccess
            }
            showCreateExpenseErrorAlert={
              !!this.props.claimProcessingv2Data.createdClaimExpenseError
            }
            CreateExpenseError={
              this.props.claimProcessingv2Data.createdClaimExpenseError
            }
            resetCreateExpenseSuccessAlert={() => {
              this.props.dispatch(actions.resetCreateExpenseSuccess());
            }}
            resetCreateExpenseErrorAlert={() => {
              this.props.dispatch(actions.resetCreateExpenseError());
            }}
            type={type}
            hasCashbackBenefit={hasCashbackBenefit}
            hasFuneralNaturalDeath={hasFuneralNaturalDeath}
            hasFuneralAccidentalDeath={hasFuneralAccidentalDeath}
            hasHospiCashIllnessBenefit={hasHospiCashIllnessBenefit}
            hasRewardsBenefits={hasRewardsBenefits}
            hasHospiCashAccidentBenefit={hasHospiCashAccidentBenefit}
            hasAccidentalDeathBenefit={hasAccidentalDeathBenefit}
            hasNaturalDeathBenefit={hasNaturalDeathBenefit}
            hasPartialPermanentDisabilityBenefit={hasPartialPermanentDisabilityBenefit}
            hasTotalPermanentDisabilityBenefit={hasTotalPermanentDisabilityBenefit}
            isOldMutualMalawiFuneralClaim={isMalawiFuneralClaim}
            isSambaFuneralClaim={isSambaFuneralClaim}
          />
          <DeleteClaimExpense
            expenseToDelete={this.props.claimProcessingv2Data.expenseToDelete}
            deleteClaimExpense={this.deleteClaimExpense.bind(this)}
            resetExpenseToDelete={this.resetExpenseToDelete.bind(this)}
            showDeleteExpenseProgressAlert={
              this.props.claimProcessingv2Data.hardDeleteExpenseLoader
            }
            showDeleteExpenseSuccessAlert={
              this.props.claimProcessingv2Data.hardDeleteExpenseSuccess
            }
            showDeleteExpenseErrorAlert={
              !!this.props.claimProcessingv2Data.deleteExpenseErrors
            }
            deleteExpenseError={
              this.props.claimProcessingv2Data.deleteExpenseErrors
            }
            resetDeleteExpenseSuccessAlert={() => {
              this.props.dispatch(actions.resetHardDeleteExpenseSuccess());
            }}
            resetDeleteExpenseErrorAlert={() => {
              this.props.dispatch(actions.resetHardDeleteExpenseError());
            }}
          />

          <EditClaimDetails
            toggleEditClaimExpenseDialog={this.toggleEditClaimExpenseDialog.bind(
              this
            )}
            openEditClaimExpenseDialog={this.state.openEditClaimExpenseDialog}
            expenseToEdit={this.props.claimProcessingv2Data.ExpenseToEdit}
            editClaimExpense={this.editClaimExpense.bind(this)}
            resetExpenseToEdit={this.resetExpenseToEdit.bind(this)}
            showEditExpenseProgressAlert={
              this.props.claimProcessingv2Data.loader
            }
            showEditExpenseSuccessAlert={
              this.props.claimProcessingv2Data.editExpenseSuccess
            }
            showEditExpenseErrorAlert={
              !!this.props.claimProcessingv2Data.editExpenseErrors
            }
            editExpenseError={
              this.props.claimProcessingv2Data.editExpenseErrors
            }
            resetEditExpenseSuccessAlert={() => {
              this.props.dispatch(actions.resetExpenseEditSuccess());
            }}
            resetEditExpenseErrorAlert={() => {
              this.props.dispatch(actions.resetExpenseEditError());
            }}
            claimguid={
              this.props.claimProcessingv2Data.claimsProcessingDcp.guid
            }
          />
        </BoxInc>
           <BoxInc
          title="Claim Notes"
          style={{ marginTop: "30px" }}
          actionButtons={[
            <ButtonInc
              variant="contained"
              color="primary"
              size="large"
              onClick={this.toggleClaimNotesDialog.bind(this)}
              hasPermision={hasAuthourity('UPDATE_CLAIM')}
            >
              Add Note
            </ButtonInc>,
          ]}
        >
          <ClaimNotes
            claim={this.props.claimProcessingv2Data.claimsProcessingDcp}
          />
          <AddClaimNotes
            toggleClaimNotesDialog={this.toggleClaimNotesDialog.bind(this)}
            openClaimNotesDialog={this.state.openClaimNotesDialog}
            handleClaimNotes={this.handleClaimNotes.bind(this)}
            claimguid={
              this.props.claimProcessingv2Data.claimsProcessingDcp.guid
            }
            showCreateNoteProgressAlert={
              this.props.claimProcessingv2Data.createClaimNoteLoader
            }
            showCreateNotesSuccessAlert={
              this.props.claimProcessingv2Data.createClaimNoteSuccess
            }
            showCreateNotesErrorAlert={
              !!this.props.claimProcessingv2Data.createClaimNoteError
            }
            CreateNotesError={this.props.claimProcessingv2Data.createClaimNoteError}
            resetCreateNotesSuccessAlert={() => {
              this.props.dispatch(actions.resetCreateClaimNoteSuccess());
            }}
            resetCreateNotesErrorAlert={() => {
              this.props.dispatch(actions.resetCreateClaimNoteError());
            }}
          />
        </BoxInc>

        <BoxInc
          title="Claims Audit"
          expanded
          style={{ marginTop: "40px" }}
          actionButtons={[
            <ButtonInc
              variant="contained"
              color="primary"
              size="large"
              onClick={this.viewCustomerProfile.bind(this)}
            >
              View Customer Profile
            </ButtonInc>,
          ]}
        >
          <ClaimAudit
            claimGuid={this.props.claimProcessingv2Data.claimsProcessingDcp.guid}

          />

        </BoxInc>

     

        <WaitingPeriodApprovalReason
          toggleWaitingPeriodApprovedDialog={this.toggleWaitingPeriodApprovedDialog.bind(
            this
          )}
          openClaimWaitingPeriodDialog={this.state.openClaimWaitingPeriodDialog}
          toggleClaimNotesDialog={this.toggleClaimNotesDialog.bind(this)}
          handleClaimNotes={this.handleClaimNotes.bind(this)}
          claimguid={this.props.claimProcessingv2Data.claimsProcessingDcp.guid}
          showCreateNoteProgressAlert={
            this.props.claimProcessingv2Data.createClaimNoteLoader
          }
          showCreateNotesSuccessAlert={
            this.props.claimProcessingv2Data.createClaimNoteSuccess
          }
          showCreateNotesErrorAlert={
            !!this.props.claimProcessingv2Data.createClaimNoteError
          }
          CreateNotesError={this.props.claimProcessingv2Data.createClaimNoteError}
          resetCreateNotesSuccessAlert={() => {
            this.props.dispatch(actions.resetCreateClaimNoteSuccess());
          }}
          resetCreateNotesErrorAlert={() => {
            this.props.dispatch(actions.resetCreateClaimNoteError());
          }}
          submitClaimAction={(claimActionPayload) =>
            this.props.dispatch(actions.claimActionRequest(claimActionPayload))
          }
        />

        <DownloadDocument
          labels={this.state.labels}
          identifier="Claims"
          entityDocument={this.props.documentGenerationData.entityDocument}
          entity={this.state.claimToDownload}
          resetEntity={() => this.setState({ claimToDownload: null })}
          templates={templateDocuments}
          getTemplates={() =>
            this.props.dispatch(
              documentActions.getTemplateDocumentsRequest("Claim")
            )
          }
          getTemplatesLoader={
            this.props.documentGenerationData.getTemplateDocumentloader
          }
          isEmptyTemplatesResponse={
            this.props.documentGenerationData.isEmptyTemplates
          }
          downloadDocument={(guid) => {
            this.props.dispatch(
              documentActions.downloadDocumentRequest({
                entity_guid: this.state.claimToDownload.guid,
                template_guid: guid,
              })
            );
          }}
          resetGetTemplateDocuments={() => {
            this.props.dispatch(documentActions.resetGetTemplateDocuments());
          }}
          resetDownloadDocument={() => {
            this.props.dispatch(documentActions.resetDocumentEntity());
          }}
          showDownloadDocumentProgressAlert={
            this.props.documentGenerationData.downloadDocumentLoader
          }
          showDownloadDocumentSuccessAlert={
            this.props.documentGenerationData.downloadDocumentSuccess
          }
          showDownloadDocumentErrorAlert={
            !!this.props.documentGenerationData.downloadDocumentError
          }
          downloadDocumentError={
            this.props.documentGenerationData.downloadDocumentError
          }
          resetDownloadDocumentSuccessAlert={() => {
            this.props.dispatch(documentActions.resetDownloadDocumentSuccess());
          }}
          resetDownloadDocumentErrorAlert={() => {
            this.props.dispatch(documentActions.resetDownloadDocumentError());
          }}
          goToTemplatesPage={() => {
            hashHistory.push("admin/view_doc_templates");
          }}
        />

        {hasAuthourity("UPDATE_CLAIM") && (
          <ClaimActionButtons
            claim={this.props.claimProcessingv2Data.claimsProcessingDcp}
            submitClaimAction={(claimActionPayload) =>
              this.props.dispatch(
                actions.claimActionRequest(claimActionPayload)
              )
            }
            loading={this.props.claimProcessingv2Data.ClaimActionLoader}
            error={this.props.claimProcessingv2Data.ClaimActionError}
            missingDocs={this.state.missingDocs}
            toggleWaitingPeriodApprovedDialog={this.toggleWaitingPeriodApprovedDialog.bind(
              this
            )}
          />
        )}
      </>
    );
  }
}
export default connect((state) => ({
  customerData: state.currentCustomer,
  documentGenerationData: state.documentGeneration,
  claimProcessingv2Data: state.claimProcessingv2Data,
  claimDashboardData: state.claimDashboardData,
  globalData: state.global,
}))(ClaimsProcessing);